import apiClient from './apiClient';

// **Θεματικά αντικείμενα** (D47, ΛΑ-05, ΛΑ-06) και **προτεινόμενες συλλογές** (D48).
//
// Δικό του module και όχι νέες μέθοδοι στο `auth.service.js`, κατά τον κανόνα
// ιδιοκτησίας των παράλληλων κλάδων: νέο αρχείο δεν συγκρούεται ποτέ.

/** Ο κατάλογος του λεξιλογίου, με το πλήθος **ορατών** συλλογών ανά θέμα. */
export function getTopics() {
    return apiClient.get('/api/topics');
}

export function createTopic({ name, description }) {
    return apiClient.post('/api/topics', { name, description });
}

export function updateTopic(id, body) {
    // ⚠ **`raw: true`, ΚΑΙ ΕΙΝΑΙ ΤΟ ΝΟΗΜΑ ΤΗΣ ΚΛΗΣΗΣ.** Η μετονομασία διαδίδεται
    // στις συλλογές (**D47**) και το **πλήθος** τους έρχεται στο `meta`, όχι στο
    // `data`. Χωρίς αυτό ο `apiClient` επιστρέφει μόνο το θέμα, το `meta` είναι
    // `undefined`, και η οθόνη ανακοινώνει «καμία συλλογή» για ενέργεια που
    // άγγιξε συλλογές — **ψευδής αριθμός σε ανατροφοδότηση της ΜΛΑ-03**, που
    // είναι χειρότερος από κανέναν γιατί ο χρήστης τον εμπιστεύεται.
    return apiClient.patch(`/api/topics/${id}`, body, { raw: true });
}

export function deleteTopic(id) {
    return apiClient.del(`/api/topics/${id}`);
}

/**
 * **D48**: οι προτεινόμενες συλλογές, με τον λόγο καθεμιάς.
 *
 * Η απόκριση φέρει `meta.interestCount`, και η οθόνη το χρειάζεται: κενός
 * κατάλογος με μηδέν ενδιαφέροντα και κενός κατάλογος με δηλωμένα ενδιαφέροντα
 * είναι **δύο διαφορετικές καταστάσεις** με εντελώς διαφορετική επόμενη ενέργεια.
 */
export function getSuggestedCollections() {
    return apiClient.getPage('/api/collections?scope=suggested');
}

/** ΛΑ-06: οι συλλογές ενός θέματος, μέσα στο εύρος ορατότητας του αιτούντος. */
export function collectionsPathForTopic(name) {
    return `/?tab=public&topic=${encodeURIComponent(name)}`;
}

export default {
    getTopics,
    createTopic,
    updateTopic,
    deleteTopic,
    getSuggestedCollections,
    collectionsPathForTopic
};
